// extracted by mini-css-extract-plugin
export default {"wrapper":"agVz_TrD","mobile":"mobile","_isPhoneSpec":"eLkcyLoh","success":"OKyfKwEp"};